import React from 'react';
import { FullLoadingProps } from './full-loading.interface';
import '@/styles/css/components/full-loading.css';

const FullLoading = ({ isLoading = false }: FullLoadingProps): JSX.Element => {
  return (
    <div
      className='full-loading v2'
      style={{ display: isLoading ? 'block' : 'none' }}
    >
      <span className='loading-icon'>loading</span>
    </div>
  );
};

export default FullLoading;
